import React, {useState,useEffect} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label } from 'semantic-ui-react'
import {WindowReload, WindowURLAdmin, WindowLocationAdmin} from '../../config/settings'
import axios from 'axios'
import DropzoneComponent from 'react-dropzone-component'


export default function UploadDocument(props) {

	function SetFileImage(file){
		  props.data(file);
	}


	 var myDropzone;
	 const [dropmessage, setdropmessage]       = useState(true);
	 const [configDropzone, setconfigDropzone] = useState(null);
	 function initCallback (dropzone) {
		 myDropzone = dropzone;
		 setconfigDropzone(dropzone);
	 }
	 function removeFile (file) {
		 if (myDropzone) {
				 myDropzone.removeFile(file);
		 }
	 }
	 function disableDropzone(){
		 myDropzone.removeEventListeners();
	 }
	 function enableDropzone(){
		 myDropzone.setupEventListeners();
	 }
	 let componentConfig = {
		 postUrl: 'no-url',
		 addRemoveLinks:true,
	 }

	 let djsConfig = {
		 acceptedFiles : 'image/jpeg, images/jpg, image/png, .pdf, .doc, .docx, .xls, .xlsx',
		 addRemoveLinks:true,
		 autoProcessQueue: false,
		 parallelUploads : 1,
		 maxFiles:1,
	 }

	 let eventHandlers = {
		 init: function(dropzone) {
				 initCallback(dropzone);
		 },
		 addedfile(file){
				 setdropmessage(false);
				 SetFileImage(file);
				 myDropzone.on("thumbnail", function(file){
					//SetFilePath(file.dataURL);
				 });
		 },
		 maxfilesexceeded(file){
				 setdropmessage(false);
				 removeFile(file);
				 disableDropzone();
		 },
		 removedfile(file){
				 if(myDropzone.getQueuedFiles().length==0){
					 setdropmessage(true);
					 SetFileImage(null);
					 enableDropzone();
					 //setavatar(tempavatar);
				 }
		 },
		 sending(file, xhr, formData) {
				 formData.append('type', 'uploadfile');
		 },
		 error(errorMessage){
			 //console.log(errorMessage);
		 }
	 }


	return (
		<React.Fragment>
			<DropzoneComponent
				 className="dropzone"
				 config={componentConfig}
				 eventHandlers={eventHandlers}
				 djsConfig={djsConfig}
				 >
				 {dropmessage&&<div className="dz-message" data-dz-message>
							<div className="dropIcon"><i className="ti-image"></i></div>
							<div className="dropText">Drop or click document file here to upload</div>
				 </div>}
			</DropzoneComponent>
			<br/>
	  </React.Fragment>
	)
}
